import { IconProps } from '../../interfaces/Icon';
import React, { FC } from 'react';
import styled from '@emotion/styled';

const LogoWrapper = styled.div`
  position: relative;
  width: 250px;
  height: 250px;
`;

const LogoSVG = styled.svg`
  position: absolute;
  width: 250px;
  height: 250px;
  &.l-1 {
    animation: rotating 7200ms linear infinite;
    transform-origin: 50% 50%;
  }

  &.l-2 {
    animation: rotating 7200ms linear reverse infinite;
    transform-origin: 50% 50%;
  }
  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const logoColors = {
  orange: '#FAA819',
  green: '#7ABA43',
  blue: '#4794D0',
  grey: '#cecece',
};

interface LoadingPlaceholderIconProps extends IconProps {
  colored?: boolean;
}

export const LoadingPlaceholderIcon: FC<LoadingPlaceholderIconProps> = props => {
  return (
    <LogoWrapper style={{ width: props.width, height: props.height }}>
      <LogoSVG
        className="l-2"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 250 250"
        {...props}
      >
        <path
          fill={props.colored ? logoColors.orange : logoColors.grey}
          d="M178.888 140.265l18.731 6.784a75.813 75.813 0 003.119-17.928h-19.929a82.906 82.906 0 01-1.921 11.144zM191.615 161.343a29.877 29.877 0 002.882-6.3l-18.731-6.783c-.48 1.212-1.201 2.423-1.681 3.635a51.54 51.54 0 01-3.847 6.057l15.369 12.84a48.27 48.27 0 006.008-9.449zM164.96 164.735a57.437 57.437 0 01-24.015 14.778 53.393 53.393 0 01-16.33 2.423h-.24l-1.68 20.108a75.307 75.307 0 0024.255-3.392 78.876 78.876 0 0033.619-21.082l-15.609-12.835z"
        />
        <path
          fill={props.colored ? logoColors.green : logoColors.grey}
          d="M129.739 68.55l3.362-19.865c-2.882-.243-5.764-.485-8.646-.485-3.119 0-6.244.242-9.365.485l3.602 19.866a84.034 84.034 0 0111.047 0zM99.96 74.126a47.486 47.486 0 018.166-3.146l2.161-.727-3.602-19.87c-1.441.485-3.119.727-4.563 1.212a61.512 61.512 0 00-12.487 5.088L99.96 74.126zM138.143 70.007a63.496 63.496 0 0112.727 5.088 54.635 54.635 0 0122.333 22.047l18.011-8.48c-7.048-13.209-17.833-24.003-30.981-31.01a76.272 76.272 0 00-18.731-7.027l-3.359 19.382z"
        />
        <path
          fill={props.colored ? logoColors.blue : logoColors.grey}
          d="M74.746 98.352c.48-.726.72-1.453 1.2-2.18L59.618 84.786c-.72 1.453-1.68 2.665-2.401 4.118a77.11 77.11 0 00-8.642 28.615 77.257 77.257 0 002.878 29.772l18.731-7.027a56.777 56.777 0 014.563-41.912zM84.351 164.977l-15.129 13.082a72.81 72.81 0 0013.932 11.629l9.845-17.444a43.129 43.129 0 01-8.648-7.267zM63.46 171.519l15.129-13.083a48.04 48.04 0 01-5.524-9.69l-18.731 7.026a92.603 92.603 0 009.126 15.747z"
        />
      </LogoSVG>
      <LogoSVG
        className="l-1"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 250 250"
        {...props}
      >
        <g>
          <path
            fill={props.colored ? logoColors.orange : logoColors.grey}
            d="M78.743 196.877a84.024 84.024 0 01-16.57-13.809l-25.936 22.289a117.29 117.29 0 0025.696 21.562l16.81-30.042zM110.681 244.12l2.882-34.16a81.642 81.642 0 01-27.617-8.722l-16.81 29.799a118.703 118.703 0 0041.545 13.083zM188.247 182.583a85.694 85.694 0 01-38.422 24.229 88.058 88.058 0 01-24.975 3.88h-2.882l-2.881 34.155a116.886 116.886 0 0040.584-5.088c21.101-6.416 40.044-18.57 54.75-35.129l-26.174-22.047z"
          />
          <path
            fill={props.colored ? logoColors.green : logoColors.grey}
            d="M239.236 160.779a128.215 128.215 0 005.764-33.19l-34.1.242a80.94 80.94 0 01-3.602 21.32l31.938 11.628zM207.058 98.758a100.015 100.015 0 013.602 20.593l34.1-.242a130.93 130.93 0 00-5.043-30.283 112.18 112.18 0 00-4.563-12.6l-30.738 14.779a58.278 58.278 0 012.642 7.753zM143.66 39.16a81.159 81.159 0 0121.613 8.237c15.042 8.029 27.342 20.438 35.3 35.614l30.738-14.778a122.208 122.208 0 00-34.065-40.871A120.917 120.917 0 00149.18 5l-5.52 34.16z"
          />
          <path
            fill={props.colored ? logoColors.blue : logoColors.grey}
            d="M49.205 83.01l2.882-5.087L24.23 58.299c-1.681 2.665-3.363 5.572-5.044 8.48A121.259 121.259 0 005.45 113.295a121.472 121.472 0 005.573 48.21l31.938-11.871a86.603 86.603 0 01-3.574-33.95 86.44 86.44 0 019.819-32.673zM85.466 46.67a74.814 74.814 0 0114.408-5.814l5.764-1.454-6.004-33.917c-3.119.726-6.484 1.453-9.605 2.422a133.656 133.656 0 00-21.853 8.965l17.29 29.798zM56.89 70.654a91.587 91.587 0 0121.132-19.866l-17.05-29.556a118.253 118.253 0 00-32.18 29.799L56.89 70.654z"
          />
        </g>
      </LogoSVG>
    </LogoWrapper>
  );
};
